/**
 * @fileoverview This file contains the top contents of the website.
 */
import { Step } from "../components/Step";
import { Link } from "react-router-dom";
import download3 from "./img/download3.png";
import download5 from "./img/download5.png";
import cmcd200folder from "./img/cmcd200folder.png";

const steps_download = [
  { step: "1.", text: "トップページの「ダウンロードページへ」をクリックします。"},
  
  { step: "2.", text: "ユーザーキーを入力し、送信ボタンをクリックします。ユーザーキーをお持ちでない場合は、ユーザー登録を行い、ユーザーキーを取得してください。"},

  { step: "3.", text: "「ダウンロード」をクリック後に以下の画面が表示されたら，赤枠内「名前をつけて保存」をクリックすると任意の場所にファイルを保存します。 青枠内∨をクリックして「保存」を選択すると，ブラウザーで設定した場所にファイルを保存します。",
    image: download3, alt: "名前を付けて保存" },

  { step: "4.", text: "ダウンロード完了画面で，「ファイルを開く」をクリックすると，ファイルの解凍が行われます。" ,
    image: download5, alt: "ファイルを開く" },

  { step: "5.", text: "解凍したフォルダが以下のファイル構成になっていることを確認して下さい。",
    image: cmcd200folder, alt: "ファイル構成",
    point_text: (<>ダウンロード終了後は，
    <Link to="/cmcd-200/HowToInstallDeviceDriver">ドライバーソフトウェアのインストール手順</Link>
    を参考にして，ドライバーソフトウェアをインストールします。</>)},
];

/**
 * Top contents
 * @returns {JSX.Element} トップページの JSX element
 */
export function HowToDownload(): JSX.Element {
  return (
    <div>
      <section className="c-section">
        <h2 className="p-heading-2">ダウンロード手順</h2>
        {steps_download.map((step, index) => (
          <Step key={index} step={step.step} text={step.text} image={step.image} point_text={step.point_text}/>
        ))}
      </section>
    </div>
  );
}
